export enum ProductType {
  Curso = 1,
  Curriculo = 2,
  ProdutoEscola = 3,
}
